module.exports = __webpack_public_path__ + "static/img/m_4.f84296ae.jpg";